<div name="convertToPdf" class="statement-container" id="convertToSpeech">
  <render-statement
    #statement
    [templateHtml]="htmlStatement"
    [validate]="validate"
    (renderHtml)="convertToPDF()"
    (inputChange)="onInputChange()"
    class="typology typology__{{ categoryId }}"></render-statement>
</div>
